var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "23px",
    viewBox: "0 0 21 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Apple_logo_black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download",
    transform: "translate(-479.000000, -432.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(416.000000, 205.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(50.000000, 214.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Apple_logo_black",
    transform: "translate(13.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3293207,7.35505144 C20.1797077,7.46188341 17.5382631,8.83170667 17.5382631,11.8776049 C17.5382631,15.4006858 20.8993981,16.6470588 21,16.6779214 C20.9845228,16.7538908 20.4660361,18.3848589 19.227859,20.0466895 C18.1238177,21.5091005 16.9707653,22.9691374 15.216681,22.9691374 C13.4625967,22.9691374 13.011178,22.0313901 10.9862425,22.0313901 C9.01289768,22.0313901 8.31126397,23 6.70679278,23 C5.10232158,23 3.9828031,21.646795 2.69561479,19.9849644 C1.20464316,18.0335004 0,15.0018465 0,12.1245054 C0,7.50936428 3.2605331,5.06172514 6.46947549,5.06172514 C8.17454858,5.06172514 9.59587274,6.09206014 10.6663801,6.09206014 C11.6852966,6.09206014 13.2742906,5 15.2141015,5 C15.9492691,5 18.5907137,5.06172514 20.3293207,7.35505144 Z M14.3841254,3.45470308 C15.1841009,2.65496316 15.75,1.54529692 15.75,0.435630689 C15.75,0.281751192 15.7345664,0.125704378 15.7011269,0 C14.399559,0.0411790204 12.8510534,0.730385782 11.9173199,1.64282618 C11.1842234,2.34503684 10.5,3.45470308 10.5,4.57954053 C10.5,4.74859124 10.5334395,4.91764196 10.5488731,4.97182488 C10.6311857,4.98482878 10.7649437,5 10.8987016,5 C12.0665115,5 13.5352768,4.34113567 14.3841254,3.45470308 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.39551005ca3eaa4a37f1a5f6802a08cf.svg";
export { ForwardRef as ReactComponent };